// RESTITUTION COORDINATES
export const GET_RESTITUTION_COORDINATES_LIST = '/restitution_coordinates/query';
export const GET_RESTITUTION_COORDINATES = '/restitution_coordinates/';
export const POST_RESTITUTION_COORDINATES = '/restitution_coordinates/';
export const PUT_RESTITUTION_COORDINATES = '/restitution_coordinates/';
export const DELETE_RESTITUTION_COORDINATES = '/restitution_coordinates/';
